module.exports = __webpack_public_path__ + "static/media/button_play.e51f74f4.svg";